"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monticello-brianza": {
    "8f736038": [{
      "hkey": "c5499843",
      "slug": "monticello-brianza",
      "name": "Monticello Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "casatevecchio": [{
      "hkey": "c5499843",
      "slug": "monticello-brianza",
      "name": "Monticello Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5302eaf": [{
      "hkey": "e917344e",
      "slug": "monticello",
      "name": "Monticello",
      "primary": true,
      "skipSearch": false
    }],
    "torrevilla": [{
      "hkey": "e917344e",
      "slug": "monticello",
      "name": "Monticello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monticello-brianza"
    }]
  }
};
exports["default"] = _default;